import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import CarouselButton from './CarouselButton';
import '../../global-sass/CarouselControls.scss';

const indexValidator = (indexRef, currIndex, indexGap) => {
	const negativeRef = currIndex - indexGap;
	const positiveRef = currIndex + indexGap;
	return negativeRef === indexRef || positiveRef === indexRef;
};

const CarouselControls = ({
	dots,
	visibleSlideIndex,
	belowPosition,
	onPlayPause,
	onPrev,
	onNext,
	onFocus,
	autoplaySlides,
	isMobile,
	labels,
	caroProps = {},
	promosLength
}) => {
	const tabIndexBase = caroProps.isCouponCaro
		? promosLength * 2 * 10
		: promosLength * 2;
	const newDots = dots.map((_item, index) => {
		let slideIndex;

		if (caroProps.isCouponCaro) {
			slideIndex =
				visibleSlideIndex === 0
					? visibleSlideIndex
					: Math.ceil(visibleSlideIndex / caroProps.slidesToScroll);
		} else {
			slideIndex = visibleSlideIndex;
		}

		const scaleButtonNormal = indexValidator(index, slideIndex, 1);
		const scaleButtonSmall = indexValidator(index, slideIndex, 2);
		const scaleButtonXS = indexValidator(index, slideIndex, 3);
		const dotButtonClasses = [];
		let activeDotClasses = '';
		if (slideIndex === index) {
			activeDotClasses = `active ${
				belowPosition ? '' : 'border border-light'
			}`;
		}
		if (
			!scaleButtonSmall &&
			!scaleButtonXS &&
			!scaleButtonNormal &&
			!(slideIndex === index)
		) {
			dotButtonClasses.push('d-none');
		}
		const key = `dot-${index}${slideIndex === index ? '-active' : ''}`;
		return (
			<li className={setClassNames(dotButtonClasses)} key={key}>
				<span
					className={setClassNames([
						'carousel-indicator',
						'dot',
						activeDotClasses,
						scaleButtonSmall ? 'dot-sm' : '',
						scaleButtonXS ? 'dot-xs' : ''
					])}
				/>
			</li>
		);
	});

	const pausePlayButtonClasses = [
		belowPosition ? 'pause-play-button-bottom' : '',
		'pause-play-button',
		'bg-transparent'
	];

	const pausePlayButtonIconClasses = [
		'd-inline-block',
		'ddc-icon',
		'font-weight-bold',
		'rounded-circle',
		autoplaySlides ? 'ddc-icon-pause' : 'ddc-icon-play',
		isMobile ? 'icon-dimension-size-4' : ''
	];

	return (
		<div
			id="controls-container"
			role="region"
			aria-label={labels.get('CAROUSEL_CONTROLS')}
		>
			<div className="bottom-controls">
				<ul aria-label="bottom-slide-index"> {newDots} </ul>
				<button
					type="button"
					className={setClassNames(pausePlayButtonClasses)}
					onClick={() => {
						onPlayPause();
					}}
					tabIndex={tabIndexBase + 3}
					aria-label={
						autoplaySlides
							? labels.get('STOP_SLIDE_ROTATION')
							: labels.get('START_SLIDE_ROTATION')
					}
				>
					<i
						role={autoplaySlides ? 'stop-button' : 'play-button'}
						className={setClassNames(pausePlayButtonIconClasses)}
					/>
				</button>
			</div>
			{isMobile ? null : (
				<div className="previous-next-arrows-area">
					<CarouselButton
						tabIndexBase={tabIndexBase}
						direction="left"
						clickEvent={onPrev}
						focusEvent={onFocus}
						mouseUpEvent={(e) => e.target.blur()}
						classes={['previous']}
					/>
					<CarouselButton
						tabIndexBase={tabIndexBase}
						direction="right"
						clickEvent={onNext}
						focusEvent={onFocus}
						mouseUpEvent={(e) => e.target.blur()}
						classes={['next']}
					/>
				</div>
			)}
		</div>
	);
};

CarouselControls.propTypes = {
	dots: PropTypes.node.isRequired,
	visibleSlideIndex: PropTypes.string.isRequired,
	belowPosition: PropTypes.bool.isRequired,
	autoplaySlides: PropTypes.bool.isRequired,
	isMobile: PropTypes.bool.isRequired,
	onPlayPause: PropTypes.func.isRequired,
	onPrev: PropTypes.func.isRequired,
	onNext: PropTypes.func.isRequired,
	onFocus: PropTypes.func.isRequired,
	labels: PropTypes.func.isRequired,
	promosLength: PropTypes.number.isRequired,
	caroProps: PropTypes.shape({
		slidesToScroll: PropTypes.number,
		isCouponCaro: PropTypes.bool
	})
};

export default CarouselControls;
